<template>
  <div class="statistics-index-wrapper">
    <tab :active="3"></tab>
    <!-- 数据 -->
    <div class="number-info">
      <div class="info-item"><span>IOS</span> <span>用户最多 </span> <span>V{{iosVersion}}</span></div>
      <div class="info-item"><span>Android</span> <span>用户最多 </span> <span>V{{androidVersion}}</span></div>
    </div>
    <!-- canvas 图表 -->
    <div class="canvas-wrapper">
      <!-- ios 版本分布 -->
      <pieios-ver-canvas :iosData="iosData"></pieios-ver-canvas>
      <!-- android 版本分布 -->
      <pieandroid-ver-canvas :androidData="androidData"></pieandroid-ver-canvas>
    </div>
    <!-- 温馨提示 -->
    <div class="tips">
      温馨提示：
      <br />
      <p>系统分布为用户使用量，整体数量会比当前用户量高。</p>
    </div>
  </div>
</template>

<script>
import {getVersion} from '@/api/statistics'
import tab from './tab'
import pieiosVerCanvas from './pieiosVerCanvas'
import pieandroidVerCanvas from './pieandroidVerCanvas'
export default {
    components: {
        tab,
        pieiosVerCanvas,
        pieandroidVerCanvas
    },
    data(){
      return {
        iosData:[],
        androidData:[],
        iosVersion: '--',
        androidVersion: '--'
      }
    },
    created(){
      this.fetchSystemData();
    },
    methods: {
      fetchSystemData(){
        getVersion().then(({data}) => {
          if(data.code == 200){
            this.iosData = data.data.iOS;
            this.androidData = data.data.android;
            let sortIosData = this.iosData.slice(0).sort((a, b) => b.count - a.count);
            let sortAndroidData = this.androidData.slice(0).sort((a, b) => b.count - a.count);
            this.iosVersion = sortIosData[0] ? sortIosData[0].versionName : '';
            this.androidVersion = sortAndroidData[0] ? sortAndroidData[0].versionName : '';
          }
        }).finally( data => {
          data = {"code":200,"data":{"android":[{"count":9,"versionName":"1.4.0"},{"count":9,"versionName":"1.5.0"},{"count":15,"versionName":"1.6.0"},{"count":30,"versionName":"1.7.0"},{"count":36,"versionName":"1.8.0"},{"count":28,"versionName":"1.9.0"},{"count":5,"versionName":"2.0.0"}],"iOS":[{"count":5,"versionName":"1.4.0"},{"count":6,"versionName":"1.5.0"},{"count":11,"versionName":"1.6.0"},{"count":20,"versionName":"1.7.0"},{"count":10,"versionName":"1.8.0"},{"count":29,"versionName":"1.9.0"},{"count":3,"versionName":"2.0.0"}]},"success":true}
        })
      }
    }
}
</script>

<style lang="scss" scoped>
.statistics-index-wrapper {
  padding: 20px ;
  .tips{
    color: #999;
  }
  .number-info{
    margin-bottom: 20px;
    padding-bottom: 15px;
    line-height: 30px;
    font-size: 14px;
    border-bottom: 1px solid #eee;
  }
  .info-item{
    padding: 0 30px;
    display: flex;
    span{
      flex: 1;
    }
  }
}
</style>
